import { useBreadcrumb } from "features/breadcrumbs";
import ListaConciliacaoBancaria from "./components/ListaConciliacaoBancaria/index";
import Container from "components/Container";

function ConciliacaoBancariaListagemPages() {
  useBreadcrumb([{ name: "Meu Financeiro" }, { name: "Conciliação Bancária" }]);

  return (
    <Container pb="32px">
      <ListaConciliacaoBancaria />
    </Container>
  );
}

export default ConciliacaoBancariaListagemPages;
